// extracted by mini-css-extract-plugin
module.exports = {"widget":"QuickBookingArticleB_widget__cSAIu","link":"QuickBookingArticleB_link__ylw7f"};